import { render, staticRenderFns } from "./sp-feature-header.vue?vue&type=template&id=36eef5bd&scoped=true"
import script from "./sp-feature-header.vue?vue&type=script&lang=js"
export * from "./sp-feature-header.vue?vue&type=script&lang=js"
import style0 from "./sp-feature-header.vue?vue&type=style&index=0&id=36eef5bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eef5bd",
  null
  
)

export default component.exports